export const jsonParse = <T>(value: unknown): T => {
  if (typeof value !== "string") return value as T;
  return JSON.parse(value);
};
